import * as styles from 'styles/atoms/MobileAppBadge.css'
import * as cn from 'classnames'
import { APP_STORE_URL, PLAY_MARKET_URL } from 'constants/media'

type MobileAppBadgeProps = {
  platform: 'ios' | 'android'
}

const MobileAppBadge = (props: MobileAppBadgeProps) =>
  props.platform === 'ios'
    ? (
      <a
        className={ cn(styles.badge, styles.ios) }
        href={ APP_STORE_URL }
        target='_blank'
      />
    )
    : (
      <a
        className={ cn(styles.badge, styles.android) }
        href={ PLAY_MARKET_URL }
        target='_blank'
      />
    )

export default MobileAppBadge
